import { useQueryParams } from '@calendly/hooks'

/**
 * Settings modal and right-rail state live in the URL for client navigation only.
 * Scheduling list data hooks should not forward those keys to API params or RTK Query cache args.
 *
 * @typedef {'profile' | 'pane' | 'paneState' | 'settings' | 'settings_tab'} ClientOnlyQueryParamKey
 * @typedef {Record<string, string | string[] | number | boolean | null | undefined>} SchedulingQueryParams
 */

/** @type {ReadonlyArray<ClientOnlyQueryParamKey>} */
const CLIENT_ONLY_QUERY_PARAM_KEYS = [
  'profile',
  'pane',
  'paneState',
  'settings',
  'settings_tab',
]

/**
 * @param {SchedulingQueryParams} [queryParams]
 * @returns {SchedulingQueryParams}
 */
const stripClientOnlyQueryParams = (queryParams = {}) => {
  const sanitizedQueryParams = { ...queryParams }

  CLIENT_ONLY_QUERY_PARAM_KEYS.forEach((key) => {
    delete sanitizedQueryParams[key]
  })

  return sanitizedQueryParams
}

/**
 * Returns query params that are safe to pass to scheduling list requests.
 *
 * @returns {SchedulingQueryParams}
 */
export const useSchedulingQueryParams = () => stripClientOnlyQueryParams(useQueryParams())
